import { render, staticRenderFns } from "./ProductFeatureDetail.vue?vue&type=template&id=fe97c876&scoped=true&"
import script from "./ProductFeatureDetail.vue?vue&type=script&lang=js&"
export * from "./ProductFeatureDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeatureDetail.vue?vue&type=style&index=0&id=fe97c876&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe97c876",
  null
  
)

export default component.exports